export default () => {
    let triggers = document.getElementsByClassName('accordion-trigger');

    Array.from(triggers).forEach(function (trigger) {
        trigger.addEventListener('click', function () {
            let targetAria = this.getAttribute('aria-controls');
            let target = document.getElementById(targetAria);
            this.classList.toggle('open');
            target.classList.toggle('open');
            trigger.ariaToggle('aria-expanded');
        });
    });
}